import { createAsyncThunk } from '@reduxjs/toolkit';
import aggregatorSectionAPIService from '../../services/aggregator_api_service';
import { campaignNavigatorUrl } from 'constants';

export const fetchTableColumnData = createAsyncThunk(
  'aggregator/fetchTableColumnData',
  async (_, { rejectWithValue }) => {
    try {
      const data = await aggregatorSectionAPIService.fetchTableColumnData();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAggregatorData = createAsyncThunk(
  'aggregator/fetchAggregatorData',
  async (params, { rejectWithValue }) => {
    try {
      const aggregatorData = await aggregatorSectionAPIService.fetchAggregatorData({
        user_input: params.userInput,
        sql_query: params.sqlQuery,
      });
      return aggregatorData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchKnowledgeBaseData = createAsyncThunk(
  'aggregator/fetchKnowledgeBaseData',
  async (_, { rejectWithValue }) => {
    try {
      const kbTableData = await aggregatorSectionAPIService.fetchUserCreatedTables();
      return kbTableData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const syncKnowledgeBaseItems = createAsyncThunk(
  'aggregator/syncKnowledgeBaseItems',
  async (items, { rejectWithValue }) => {
    try {
      const syncResponse = await aggregatorSectionAPIService.syncKnowledgeBaseItems(items);
      return syncResponse;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const exportWorkbenchFile = createAsyncThunk(
  'aggregator/exportWorkbenchFile',
  async ({ file, outputFileName, isMeta, columnFileMap = null, isExistingTable }, { rejectWithValue }) => {
    try {

      const FILE_LIMIT = 6 * 1024 * 1024; // 8MB
      let s3Key = null;

      // ✅ BIG FILE → upload to EC2 → S3
      if (file && file.size > FILE_LIMIT && !isMeta) {

        const formData = new FormData();
        formData.append("file", file);

        const uploadRes = await fetch(`${campaignNavigatorUrl}api/v1/amai/upload_to_s3`, {
          method: "POST",
          body: formData
        });

        const uploadData = await uploadRes.json();
        //if (!uploadRes.ok) throw uploadData;
        s3Key = uploadData.data.s3Key;

      }
      else {
        s3Key = '';
      }
      // ✅ CALL EXISTING API (UNCHANGED ENDPOINT)
      const data =
        await aggregatorSectionAPIService.exportWorkbenchFileApi({
          file,
          s3Key,
          outputFileName,
          isMeta,
          columnFileMap,
          isExistingTable
        });

      return data;

    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportSchemaToWorkbenchFile = createAsyncThunk(
  'aggregator/exportSchemaToWorkbenchFile',
  async ({ outputSchema, outputFileName, isExistingTable }, { rejectWithValue }) => {
    try {
      const data = await aggregatorSectionAPIService.exportSchemaToWorkbenchFileApi({ outputSchema, outputFileName, isExistingTable });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);